import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_FriendFunctionClass = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Friend Function and Class"
      videos={[
        "https://www.youtube.com/embed/HqnVgvBR4pA", // Friend Functions in C++ Programming
      ]}
      takeaways={[ 
        { text: "A bit more important topic; questions can be straightforward or indirect." },
        { text: "Be prepared for differences between friend functions and member functions." },
        { text: "Sometimes, questions ask for implementing a scenario using a friend function." },
      ]}
      questions={[
        "1) What are the differences between the friend function and the member function of a C++ class? Explain the friend function with a suitable example (C++ program).",
        "2) Explain about friend function and friend class with an appropriate sample program of your choice.",
        "3) Write a C++ program to add two complex numbers using the friend function.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_FriendFunctionClass;
